import { Injectable, inject } from '@angular/core';
import {
  type ReportingComparisonRowsHttpBody,
  type ReportingComparisonRowsResponseDto,
} from 'ag-common-lib/lib/contracts/reporting-api.contracts';
import { ReportingApiService } from '../../../services/reporting-api.service';

/**
 * One comparison table's rows, asked for the way a grid asks.
 *
 * Separate from the page's own request on purpose: a table growing by a page must not refetch
 * the comparison, its charts and its totals alongside the rows it actually wants.
 */
@Injectable()
export class ProductionComparisonRowsService {
  private static readonly rowsPath = '/api/reports/comparison/rows';

  private readonly reportingApiService = inject(ReportingApiService);

  getRows(body: ReportingComparisonRowsHttpBody): Promise<ReportingComparisonRowsResponseDto> {
    return this.reportingApiService.request<ReportingComparisonRowsResponseDto>(
      ProductionComparisonRowsService.rowsPath,
      { method: 'POST', body },
    );
  }
}
